export const OnboardingStep = {
    SELECT_SCENARIO: `SelectScenario`,
    CONVERSATION_PLAYER_INPUT: `ConversationPlayerInput`,
    CONVERSATION_HAND_OFF: `ConversationHandOff`,
};